const addTestId = (id?: string) =>
  process.env.NODE_ENV === 'production' && !window.IS_SLAB_STORYBOOK
    ? {}
    : { 'data-testid': id };

export default addTestId;
